/**
 * ProgressFilter Component
 * Range slider for filtering OKRs by progress percentage
 */

import React from 'react';

interface ProgressFilterProps {
  minValue: number;
  maxValue: number;
  onChange: (min: number, max: number) => void;
  availableRange: { min: number; max: number };
}

export const ProgressFilter: React.FC<ProgressFilterProps> = ({
  minValue,
  maxValue,
  onChange,
  availableRange,
}) => {
  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-stone-700">
        Progress Range
      </label>

      <div className="space-y-2">
        {/* Min Value Slider */}
        <div className="space-y-1">
          <div className="flex items-center justify-between text-xs text-stone-600">
            <span>Minimum</span>
            <span className="font-medium text-primary-600">{minValue}%</span>
          </div>
          <input
            type="range"
            min={0}
            max={100}
            value={minValue}
            onChange={(e) => {
              const newMin = parseInt(e.target.value);
              if (newMin <= maxValue) {
                onChange(newMin, maxValue);
              }
            }}
            className="w-full h-2 bg-stone-200 rounded-lg appearance-none cursor-pointer accent-primary-600"
          />
        </div>

        {/* Max Value Slider */}
        <div className="space-y-1">
          <div className="flex items-center justify-between text-xs text-stone-600">
            <span>Maximum</span>
            <span className="font-medium text-primary-600">{maxValue}%</span>
          </div>
          <input
            type="range"
            min={0}
            max={100}
            value={maxValue}
            onChange={(e) => {
              const newMax = parseInt(e.target.value);
              if (newMax >= minValue) {
                onChange(minValue, newMax);
              }
            }}
            className="w-full h-2 bg-stone-200 rounded-lg appearance-none cursor-pointer accent-primary-600"
          />
        </div>
      </div>

      {/* Range Display */}
      <div className="flex items-center justify-between px-3 py-2 bg-primary-50 border border-primary-200 rounded-lg">
        <span className="text-sm font-medium text-primary-900">
          {minValue}% - {maxValue}%
        </span>
        <span className="text-xs text-primary-600">
          Available: {availableRange.min}% - {availableRange.max}%
        </span>
      </div>
    </div>
  );
};
